<template>
  <div class="rtl">
    <v-card-title class=" mb-5 secondary--text">
      لیست دعوت ها
    </v-card-title>
    <m-datatable
        :headers="invitationsHeaders"
        :items="invitations"
        :show-applied-filters="false"
        :showExportBtns="false"
    >
      <template #item.action="{ item }">
        <template v-if="item.status == 'p'">
          <v-btn
              depressed class="rounded-lg"
              @click="confirmInvitation(item)"
              color="success white--text"
          >تایید دعوت
          </v-btn
          >
          <v-btn
              depressed class="rounded-lg"
              @click="changeInvitationStatus(item, 'r')"
              color="error white--text mr-1"
          >رد دعوت
          </v-btn
          >
        </template>
        <span v-else>-</span>
      </template>
    </m-datatable>

    <v-dialog
        @click:outside="confirmInvitationDialog = false"
        v-model="confirmInvitationDialog"
        scrollable
        max-width="400px"
        transition="dialog-transition"
    >
      <v-card class="rounded-lg pa-2">
        <v-card-title class="mt-0 secondary--text">تایید دعوت</v-card-title>
        <v-card-subtitle class="mt-0">
          لطفا کد تاییدی که از کسب و کار
          <span v-if="invitation">{{ invitation.company_name }}</span>
          دریافت کرده اید را وارد کنید
        </v-card-subtitle>
        <v-card-text>
          <v-text-field
              color="secondary"
              class="text-field-ltr rounded-lg mt-2"
              label="کد تایید دریافتی"
              v-model="confirmationCode"
          />
        </v-card-text>
        <v-card-actions class="mb-2">
          <v-btn
              @click="changeInvitationStatus(invitation, 'a', confirmationCode)"
              block
              depressed class="rounded-lg"
              color="success white--text "
          >تایید
          </v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>
<script>
import {MFormMixin} from "@/components/m-form";
import getRolesApi from "../role/getRolesApi";
import UserApi from "@/views/panel/user/api";
import CompanyMixin from "@/views/panel/company/mixin";
import AuthMixin from "@/views/auth/mixin";

export default {
  mixins: [MFormMixin, getRolesApi, UserApi, CompanyMixin, AuthMixin],
  props: {
    isInvitation: {
      default: false,
    },
  },
  data() {
    return {
      baseUrl: "companies/companyUserInvitations",
      appendSlash: true,
      confirmInvitationDialog: false,
      roles: [],
      items: [],
      invitations: [],
      invitation: null,
      confirmationCode: null,
      financialYears: [],
      permissionBasename: "user",
    };
  },
  computed: {
    invitationsHeaders() {
      return [
        {
          text: "کسب و کار",
          value: "company_name",
        },
        {
          text: "وضعیت",
          value: "status",
          type: "select",
          items: this.UserInvitationStatuses,
        },
        {
          text: "",
          value: "action",
          filterable: false,
          sortable: false,
        },
      ];
    },

    title() {
      return "";
    },
    cols() {
      return [
        {
          text: "کد ملی",
          value: "username",
        },
        {
          text: "کد تایید",
          value: "confirmation_code",
        },
        {
          text: "وضعیت",
          value: "status",
          type: "select",
          items: this.UserInvitationStatuses,
        },
      ];
    },
  },
  mounted() {
    this.getInvitations();
  },
  methods: {
    confirmInvitation(invitation) {
      this.invitation = invitation;
      this.confirmInvitationDialog = true;
    },
    changeInvitationStatus(item, status, confirmationCode = null) {
      this.request({
        url: this.endpoint(`users/invitations/changeStatus`),
        method: "post",
        data: {
          id: item.id,
          status: status,
          confirmation_code: confirmationCode,
        },
        success: () => {
          this.confirmInvitationDialog = false;
          this.confirmationCode = null;
          this.successNotify();
          this.getInvitations();
        },
      });
    },
    getInvitations() {
      this.request({
        url: this.endpoint(`users/invitations`),
        method: "get",
        success: (data) => {
          this.invitations = data;
        },
      });
    },
  },
};
</script>
